module.exports = __webpack_public_path__ + "media/images/seamless-883124fe303b5bd1b5c1f2a52d8f3c67.svg";